export const PRODUCT_DOMAIN = 'https://welfarehello.com';

const ENV = {
  NODE_ENV: process.env.NODE_ENV,
  NEXT_PUBLIC_DOMAIN: process.env.NEXT_PUBLIC_DOMAIN as string,
  NEXT_PUBLIC_API_DOMAIN: process.env.NEXT_PUBLIC_API_DOMAIN as string,
  NEXT_PUBLIC_GOOGLE_CLIENT_ID: process.env
    .NEXT_PUBLIC_GOOGLE_CLIENT_ID as string,
  NEXT_PUBLIC_KAKAO_CLIENT_ID: process.env
    .NEXT_PUBLIC_KAKAO_CLIENT_ID as string,
  NEXT_PUBLIC_NAVER_CLIENT_ID: process.env
    .NEXT_PUBLIC_NAVER_CLIENT_ID as string,
  NEXT_PUBLIC_APPLE_CLIENT_ID: process.env
    .NEXT_PUBLIC_APPLE_CLIENT_ID as string,
  NEXT_PUBLIC_TOSS_CLIENT_ID: process.env.NEXT_PUBLIC_TOSS_CLIENT_ID as string,
  NEXT_PUBLIC_JEJU_API_DOMAIN: process.env
    .NEXT_PUBLIC_JEJU_API_DOMAIN as string,
  NEXT_PUBLIC_JEJU_YOUTHDREAM_API_KEY: process.env
    .NEXT_PUBLIC_JEJU_YOUTHDREAM_API_KEY as string,
  NEXT_PUBLIC_DPG_API_DOMAIN: process.env.NEXT_PUBLIC_DPG_API_DOMAIN as string,
  NEXT_PUBLIC_NAVER_CLOUD_CLIENT_ID: process.env
    .NEXT_PUBLIC_NAVER_CLOUD_CLIENT_ID as string,
  NEXT_PUBLIC_MOBILE_OK_URL: process.env.NEXT_PUBLIC_MOBILE_OK_URL as string,
  NEXT_PUBLIC_EZ_IOK_URL: process.env.NEXT_PUBLIC_EZ_IOK_URL as string,
  NEXT_PUBLIC_KB_APP_PREFIX_PARAM_BASE_URL: process.env
    .NEXT_PUBLIC_KB_APP_PREFIX_PARAM_BASE_URL as string,
  NEXT_PUBLIC_CHANNEL_TALK_PLUGIN_KEY: process.env
    .NEXT_PUBLIC_CHANNEL_TALK_PLUGIN_KEY as string,
  NEXT_PUBLIC_ADROP_APP_ID: process.env.NEXT_PUBLIC_ADROP_APP_ID as string,
};

for (const key in ENV) {
  if (!ENV[key as keyof typeof ENV]) {
    throw new Error(`환경변수 ${key}이 없습니다.`);
  }
}

const IS_PRODUCT = ENV.NEXT_PUBLIC_DOMAIN === PRODUCT_DOMAIN;
const IS_DEV = ENV.NODE_ENV === 'development';

const BASE_URL = IS_DEV
  ? ENV.NEXT_PUBLIC_DOMAIN
  : ENV.NEXT_PUBLIC_DOMAIN.replace('https://', 'https://www.');

export { BASE_URL, ENV, IS_DEV, IS_PRODUCT };
